import * as React from "react";
import {CSSProperties} from "react";
import "./tooltip.scss";
import {isNullOrUndefined} from "util";
import classNames = require("classnames");

interface IProps {
	/**
	 * On outside click callback
	 */
	onOutsideClick?: () => void;
	/**
	 * Reference to parent object that usually trigger tooltip show action.
	 */
	parentRef: any;
	/**
	 * Custom styles for whole component.
	 */
	style?: CSSProperties;
	/**
	 * Custom CSS class name.
	 */
	customClass?: string;
	/**
	 * Display dropdown always on the right of parent component.
	 */
	dropdownAlwaysOnRight?: boolean;
	/**
	 * Display dropdown with arrow on top, under parent component.
	 */
	arrowOnTop?: boolean
}

interface IState {
	dropDownOnLeft: boolean;
	dropdownOnTop: boolean;
	isParentSmall: boolean;
}

export default class Tooltip extends React.Component<IProps, IState> {

	dropDown: HTMLDivElement;

	constructor(props: IProps) {
		super(props);
		this.state = {
			dropDownOnLeft: false,
			dropdownOnTop: false,
			isParentSmall: false
		};
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	}

	componentDidMount() {
		const parentBox = this.props.parentRef.getBoundingClientRect();
		const onLeft = this.props.dropdownAlwaysOnRight ? false : parentBox.right + parentBox.width > window.innerWidth / 2;
		const onTop = parentBox.top + parentBox.height / 2 > window.innerHeight / 2;
		this.setState({
			dropDownOnLeft: onLeft,
			dropdownOnTop: onTop,
			isParentSmall: parentBox.height < 40
		});
		document.addEventListener("mousedown", this.handleOutsideClick);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleOutsideClick);
	}

	render() {
		const classFromProps = classNames({
			"a-tooltip": true,
			"is-parent-small": this.state.isParentSmall,
			"is-left": this.state.dropDownOnLeft && !this.props.arrowOnTop,
			"is-right": !this.state.dropDownOnLeft,
			"is-top": this.state.dropdownOnTop && !this.props.arrowOnTop,
			"is-bottom": !this.state.dropdownOnTop,
			"is-arrow-on-top": this.props.arrowOnTop,
			[`${this.props.customClass}`]: !!this.props.customClass
		});

		const parentBox = this.props.parentRef.getBoundingClientRect();
		const top = this.state.dropdownOnTop ? parentBox.bottom - this.dropDown.getBoundingClientRect().height : parentBox.top;
		const left = this.state.dropDownOnLeft ? parentBox.left - this.dropDown.getBoundingClientRect().width - 10 :
			parentBox.left + parentBox.width + 10;

		const styleFromProps = {
			top: this.props.arrowOnTop ? top + 80 : top,
			left: this.props.arrowOnTop ? left + 60 : left
		};

		const styles = {...styleFromProps, ...this.props.style};

		return (
			<div className={classFromProps} ref={(dd) => this.dropDown = dd} style={styles}>
				<div className="a-tooltip_content">
					{this.props.children}
				</div>
			</div>
		);
	}

	/**
	 * Handle click outside dropdown list.
	 */
	handleOutsideClick(evt: Event) {
		if (this.dropDown && !this.dropDown.contains(evt.target as HTMLElement) &&
			!this.props.parentRef.contains(evt.target as HTMLElement) &&
			!isNullOrUndefined(this.props.onOutsideClick)) {
			this.props.onOutsideClick();
		}
	}
}